import { Component, OnInit } from "@angular/core";
import { BreadcrumbService } from "src/app/shared/breadcrumb/breadcrumb.service";

export interface Breadcrumb {
  text: string;
  routerLink?: string;
  color?: string;
  queryParams?: { [id: string]: string };
}

@Component({
  selector: "app-breadcrumb",
  templateUrl: "./breadcrumb.component.html",
  styleUrls: ["./breadcrumb.component.scss"],
})
export class BreadcrumbComponent implements OnInit {
  breadcrumbs: Breadcrumb[] = [];

  constructor(private breadcrumbService: BreadcrumbService) {}

  ngOnInit() {
    this.breadcrumbs = [];
    this.breadcrumbService.breadcrumbs.subscribe((res) => {
      this.breadcrumbs = res;
    });
  }
}
